module.exports = __webpack_public_path__ + "static/media/Time-management.002992a7.svg";